import React from 'react';

// Helper function for copy-to-clipboard
const copyToClipboard = (text, fieldName) => {
  navigator.clipboard.writeText(text)
    .then(() => {
      alert(`${fieldName} copied to clipboard!`);
    })
    .catch(err => {
      console.error(`Failed to copy ${fieldName}: `, err);
      alert(`Failed to copy ${fieldName}.`);
    });
};

// Reusable display box component
function InfoBox({ label, data, copyData = data }) {
  // Ensure data is a string for display and copying non-string types appropriately
  const displayData = typeof data === 'string' ? data : JSON.stringify(data, null, 2);
  const dataToCopy = typeof copyData === 'string' ? copyData : JSON.stringify(copyData, null, 2);

  return (
    <div className="mb-4 p-4 border border-gray-300 rounded-lg bg-gray-50 relative">
      <label className="block text-sm font-medium text-gray-700 mb-1">{label} foo</label>
      <pre className="whitespace-pre-wrap break-words text-sm text-gray-900 bg-white p-2 border rounded max-h-48 overflow-y-auto">
        {displayData || 'N/A'}
      </pre>
      <button
        onClick={() => copyToClipboard(dataToCopy || '', label)}
        disabled={!dataToCopy}
        className="absolute top-2 right-2 bg-blue-500 text-white px-2 py-1 rounded text-xs hover:bg-blue-600 disabled:opacity-50"
        aria-label={`Copy ${label}`}
      >
        Copy
      </button>
    </div>
  );
}


function FinalAgentModal({ isOpen, onClose, agentData }) {
  if (!isOpen) return null;

  const {
    name = '',
    description = '',
    instructions = '',
    knowledgeSourcePills = [],
    selectedCapabilities = []
  } = agentData || {};

  // Format knowledge sources for display and copying
  const formattedKnowledgeSources = knowledgeSourcePills
    .map(ks => `- ${ks.type}: ${ks.value}`)
    .join('\n');

  // Format capabilities for display and copying
  const formattedCapabilities = selectedCapabilities.length > 0
    ? selectedCapabilities.map(cap => `- ${cap}`).join('\n')
    : 'None';


  return (
    // Modal backdrop with blur
    <div className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm flex justify-center items-center z-50 p-4">
      {/* Modal content */}
      <div className="bg-white rounded-lg shadow-xl p-6 w-full max-w-3xl max-h-[90vh] overflow-y-auto">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-2xl font-semibold text-gray-800">Agent Configuration</h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-800 text-2xl font-bold"
            aria-label="Close modal"
          >
            &times;
          </button>
        </div>

        <p className="text-sm text-gray-600 mb-6">
          Copy the following details and paste them into the corresponding fields in the Microsoft Copilot agent creation tool.
        </p>

        <InfoBox label="Agent Name" data={name} />
        <InfoBox label="Description" data={description} />
        <InfoBox label="Instructions" data={instructions} />
        <InfoBox label="Knowledge Sources" data={formattedKnowledgeSources} />
        <InfoBox label="Capabilities" data={formattedCapabilities} />


        <div className="mt-6 flex justify-end">
          <button
            onClick={onClose}
            className="bg-gray-300 text-gray-800 px-4 py-2 rounded-lg hover:bg-gray-400"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}

export default FinalAgentModal;
